import { render, staticRenderFns } from "./ViewOrganizationUserInspectionRecords.vue?vue&type=template&id=9740bed4&scoped=true"
import script from "./ViewOrganizationUserInspectionRecords.vue?vue&type=script&lang=js"
export * from "./ViewOrganizationUserInspectionRecords.vue?vue&type=script&lang=js"
import style0 from "./ViewOrganizationUserInspectionRecords.vue?vue&type=style&index=0&id=9740bed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9740bed4",
  null
  
)

export default component.exports